import {NgModule} from "@angular/core";

import {NumberScalePipe} from "./pipes/number-formatter/number-formatter";
import {CurrencyValuePipe} from './pipes/currency-formatter/currency-formatter';
import {FormattingService} from './formatting/formatting.service';

import { ExceptionAndLoggingService } from "./logging/exception-logging-service";
import { RepositoryService } from "./repository.service";
import { ErrorDialogComponent } from "./logging/errors/error-dialog/error-dialog.component";
import { MaterialModule } from "../material/material.module";

@NgModule({
	imports: [
        MaterialModule
	],

	declarations: [
		NumberScalePipe,
        CurrencyValuePipe,
        ErrorDialogComponent
	],

	exports: [
		NumberScalePipe
	],

	providers: [
		NumberScalePipe,
        CurrencyValuePipe,
		FormattingService,
        ExceptionAndLoggingService,
        RepositoryService
	]
})
export class LINQUtilsModule {
}

